import { http } from '@admitkard/uiutils/http';
import { env } from '@admitkard/uiutils/env';

const UNIVERSITY_API = {
  GET_UNIVERSITIES: `${env.KDU_URL}/universities/`,
};

export interface BEUniversity {
  _id: string;
  name: string;
  universityCountryRank: number;
  logoUrl: string;
  slug: string;
  city: {
    _id: string;
    name: string;
    slug: string;
  };
  state: {
    _id: string;
    name: string;
    slug: string;
  };
  country: {
    _id: string;
    name: string;
    slug: string;
  };
  rawCampus: string;
}

export interface BEUniversityListing {
  UniversityList: BEUniversity[];
}

export const fetchUniversityList = async() => {
  const allUniversititesUrl =
    `${UNIVERSITY_API.GET_UNIVERSITIES}getGeneric?` +
    `select=name&select=city&select=state&select=slug` +
    `&select=logoUrl&select=universityCountryRank&populate=city` +
    `&populate=state&populate=country&select=country&select=rawCampus`;
  try {
    const response = await http.get<BEUniversity[]>(allUniversititesUrl);
    return response.data;
  } catch(error: any) { // TODO: @piyush errorType {
    throw error;
  }
};
